import { useMemo, useState } from 'react';
import { match } from 'ts-pattern';

import { EMPTY_ARR } from '~/core/shared/constants';
import { useUserData } from '~/core/shared/contexts/UserContext';
import { useCan } from '~/core/shared/hooks/useCan';
import { useEventHandler } from '~/core/shared/hooks/useEventHandler';
import { SummaryActionResult, SummaryControl } from '~/core/shared/types';
import { SummaryBlockElementProps } from '../../types/SummaryBlockElementProps';

export const useSummaryBlockElement = (
  content: SummaryBlockElementProps['content'],
  contentElements: SummaryBlockElementProps['contentElements'],
) => {
  const [entries, setEntries] = useState(Object.entries(contentElements));
  const { user } = useUserData();
  const { can } = useCan();

  // yuck! who thought side effects from the backend was a good idea?
  const handleSideEffects = useEventHandler(
    async (index: number, sideEffects: SummaryActionResult['sideEffects']) => {
      sideEffects.forEach((sideEffect) => {
        match(sideEffect)
          .with('deleted', () =>
            setEntries([
              ...entries.slice(0, index),
              ...entries.slice(index + 1),
            ]),
          )
          .run();
      });
    },
  );

  const controls = useMemo(() => {
    if (!user) return EMPTY_ARR;
    return (content?.controls ?? EMPTY_ARR).filter(
      ({ permission, position }: SummaryControl) =>
        permission && can(permission) && position === 'entity',
    );
  }, [content?.controls, user]);

  const totalEntries = entries.length;

  return {
    handleSideEffects,
    controls,
    entries,
    totalEntries,
  };
};
